import { notification } from "antd";
import { onMessage } from "firebase/messaging";
import { useEffect } from "react";
import CustomNotification from "../components/common/CustomNotification";
import { useUploadMobileTokenMutation } from "../features/auth/authApi";
import { generateToken, messaging } from "../utils/firebaseConfig";

type MSGType = {
  title: string;
  body: string;
};

export default function useFirebaseNotification(fetchApi: () => void) {
  // const dispatch = useAppDispatch();
  const [api, contextHolder] = notification.useNotification();
  const [uploadMobileToken] = useUploadMobileTokenMutation();

  if ("serviceWorker" in navigator) {
    window.addEventListener("load", () => {
      navigator.serviceWorker
        .register("/firebase-messaging-sw.js")
        .then((registration) => {
          // console.log(
          //   "Service Worker registered with scope: ",
          //   registration.scope
          // );
        })
        .catch((error) => {
          // console.error("Service Worker registration failed: ", error);
        });
    });
  }

  // Notification with firebase
  useEffect(() => {
    generateToken().then((el) => {
      // console.log(el);
      uploadMobileToken({
        mobile_token: el,
      });
      // dispatch(setNotificationToken(el));
    });

    const openNotification = (msg: MSGType) => {
      // console.log(msg);
      fetchApi();
      api.open({
        message: null,
        description: <CustomNotification title={msg.title} body={msg?.body} />,
        duration: 5,
        className: "custom-notification",
      });
    };

    onMessage(messaging, (payload) => {
      const notification = payload?.notification as MSGType;
      openNotification(notification);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [api]);

  return {
    contextHolder,
  };
}
